<template>
  <section>
    <nav-component :titulo="'Historial de Inventario'" />
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag="router-link" to="/">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item active>Historial de Inventario</b-breadcrumb-item>
    </b-breadcrumb>

    <busqueda-de-producto @seleccionado="onSeleccionadoProducto" @deseleccionado="onDeseleccionadoProducto" />
    <busqueda-en-fecha @seleccionada="onBusquedaEnFecha" />

    <div class="table-toolbar mt-3">
      <div class="table-toolbar-left">
        <b-select v-model="porPagina" @input="cambiarPorPagina" size="is-small">
          <option :value="10">10 / pág</option>
          <option :value="20">20 / pág</option>
          <option :value="50">50 / pág</option>
        </b-select>
        <b-select v-model="filtros.proveedor" @input="onFiltroProveedor" size="is-small">
          <option value="">Todos los proveedores</option>
          <option v-for="p in proveedores" :value="p.id" :key="p.id">{{ p.nombre }}</option>
        </b-select>
        <span style="font-size:0.78rem;color:var(--color-text-dim)">{{ total }} movimientos</span>
      </div>
      <div class="table-toolbar-right">
        <b-button type="is-primary" size="is-small" icon-left="printer" tag="a" :href="printHref" target="_blank" rel="noopener noreferrer">
          Imprimir
        </b-button>
      </div>
    </div>

    <b-table
      class="box"
      :data="movimientos"
      :paginated="true"
      :per-page="porPagina"
      :current-page="pagina"
      :total="total"
      :backend-pagination="true"
      :pagination-rounded="true"
      pagination-position="bottom"
      @page-change="onCambioPagina"
    >
      <b-table-column field="nombreProducto" label="Producto"  sortable v-slot="props">{{ props.row.nombreProducto }}</b-table-column>
      <b-table-column field="cantidad"       label="Cantidad"  sortable v-slot="props">
        <span class="has-text-weight-bold" :class="props.row.signo === '+' ? 'has-text-success' : 'has-text-danger'">
          {{ props.row.signo }}{{ props.row.cantidad }}
        </span>
      </b-table-column>
      <b-table-column field="tipo"           label="Tipo"      sortable v-slot="props">{{ props.row.tipo }}</b-table-column>
      <b-table-column field="monto"          label="Monto"     sortable v-slot="props">
        <span v-if="props.row.monto !== undefined">${{ formatoMonto(props.row.monto) }}</span>
      </b-table-column>
      <b-table-column field="fecha"          label="Fecha"     sortable v-slot="props">{{ formatFecha(props.row.fecha) }}</b-table-column>
      <b-table-column field="nombreUsuario"  label="Usuario"   sortable v-slot="props">{{ props.row.nombreUsuario }}</b-table-column>
      <b-table-column field="nombreCliente"  label="Cliente"   sortable v-slot="props">{{ props.row.nombreCliente || 'N/A' }}</b-table-column>
      <b-table-column field="nombreProveedor" label="Proveedor" sortable v-slot="props">{{ props.row.nombreProveedor || 'N/A' }}</b-table-column>
    </b-table>

    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false" />
  </section>
</template>

<script>
import NavComponent from '../Extras/NavComponent'
import HttpService from '../../Servicios/HttpService'
import Utiles from '../../Servicios/Utiles'
import BusquedaDeProducto from './BusquedaDeProducto.vue'
import BusquedaEnFecha from '../Extras/BusquedaEnFecha.vue'

export default {
  name: 'HistorialComponent',
  components: { NavComponent, BusquedaDeProducto, BusquedaEnFecha },

  data: () => ({
    cargando: false,
    movimientos: [],
    proveedores: [],
    pagina: 1,
    porPagina: 20,
    total: 0,
    filtros: { proveedor: '', productoId: null, fechaInicio: "", fechaFin: "" },
  }),

  mounted() {
    this.filtros.proveedor = this.$route.query.proveedor || ''
    this.obtenerMovimientos()
    this.obtenerProveedores()
  },

  computed: {
    printHref() {
      let href = '#/pdf/movimientos'
      const entries = Object.entries(this.filtros).filter(([, v]) => Boolean(v))
      if (entries.length === 0) return href
      return `${href}?${new URLSearchParams(Object.fromEntries(entries)).toString()}`
    },
  },

  methods: {
    formatoMonto(v) { return Utiles.formatoMonto(v) },
    formatFecha(f) {
      return new Date(f).toLocaleDateString('es-ES', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' }).replace(/\//g, '-')
    },

    onCambioPagina(p) { this.pagina = p; this.obtenerMovimientos() },
    cambiarPorPagina() { this.pagina = 1; this.obtenerMovimientos() },
    onFiltroProveedor() { this.pagina = 1; this.obtenerMovimientos() },

    obtenerMovimientos() {
      this.cargando = true
      HttpService.obtenerConConsultas('ventas.php', {
        accion: 'historial',
        proveedor:   this.filtros.proveedor   || null,
        productoId:  this.filtros.productoId  || null,
        fechaInicio: this.filtros.fechaInicio || null,
        fechaFin:    this.filtros.fechaFin    || null,
        pagina:      this.pagina,
        porPagina:   this.porPagina,
      }).then(resp => {
        if (Array.isArray(resp)) {
          resp.sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
          this.movimientos = resp
          this.total = resp.length
        } else {
          this.movimientos = resp.movimientos || resp.data || []
          this.total = resp.total || this.movimientos.length
        }
        this.cargando = false
      })
    },

    obtenerProveedores() {
      HttpService.obtenerConConsultas('proveedores.php', { accion: 'obtener' })
        .then(p => { this.proveedores = Array.isArray(p) ? p : (p.proveedores || []) })
    },

    onSeleccionadoProducto(producto) { this.filtros.productoId = producto.id; this.pagina = 1; this.obtenerMovimientos() },
    onDeseleccionadoProducto()       { this.filtros.productoId = null;        this.pagina = 1; this.obtenerMovimientos() },
    onBusquedaEnFecha(fechas) {
      this.filtros.fechaInicio = fechas[0]?.toISOString().split('T')[0] || ""
      this.filtros.fechaFin   = fechas[1]?.toISOString().split('T')[0] || ""
      this.pagina = 1; this.obtenerMovimientos()
    },
  },
}
</script>
